export const validLevelOneStatuses = [
  "Pending Level 1 Review",
  // "Pending Level 2 Review",
  // "Pending Payment Level 2 Review",
  // "Pending Payment",
  // "Payment Rejected By Level 2 Reviewer",
  // "Returned For Repayment By Level 2 Reviewer",
  // "Pending Level 3 Review",
  // "Rejected By Level 2 Reviewer",
  // "Returned By Level 2 Reviewer",
  // "Rejected By Level 3 Reviewer",
  "Returned By Level 1 Reviewer",
];

// export const statusesApplicableForPaymentScreen = [
//   "Pending Payment Level 2 Review",
//   "Payment Rejected By Level 2 Reviewer",
//   "Returned For Repayment By Level 2 Reviewer",
// ];
